import React from 'react'
import LgyField from 'app/components/util/lgy-field/LgyField'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { getUserTypesFromAffiliations, accountStatusStringFromCode, getUserAffiliation } from 'app/utils/userUtils'
import { formatDateToDisplayString } from 'app/utils/dateTimeUtils'

export const AccountInformation = ({ user }) =>
  <LgySubsection header='Account Information'>
    <LgyField label='User ID' value={user.portalId} />
    <LgyField label='User Affiliation' value={getUserAffiliation(user)} />
    {user.isAffiliate && <LgyField label='User Type(s)' value={getUserTypesFromAffiliations(user.affiliations)} />}
    <LgyField label='Active' value={user.active ? 'Yes' : 'No'} />
    <LgyField label='Account Status' value={accountStatusStringFromCode(user.accountStatusCode)} />
    <LgyField label='Last Login' value={formatDateToDisplayString(new Date(user.lastLoginDate))} />
  </LgySubsection>

export default AccountInformation
